import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import "./CatelogPage.css";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { getRequestcall } from "../../comman/util/getRequest";
import {
  SERVICES,
  STORE_DETAIL,
  SUBCATEGORY_LIST,
} from "../../constants/apiurl";
import CategorycardPage from "../../comman/components/CategorycardPage";
import ButtonPage from "../../comman/button/ButtonPage";
import { clearStoredetail } from "../../dashboard/redux/actions";
import { fetchLogindata } from "../../login/redux/actions";

function CatelogPage(props) {
  
  let service_card = {
    height:"160px",
    minHeight:"0px",
}
  let goods_card = {
    minHeight: "330px"
  }

  const [categorylist, setCategorylist] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation(); 

  useEffect(() => {
    (async () => getStoreDetail())();
    // eslint-disable-next-line
  }, [props?.language]);

  const getStoreDetail = async () => {
    props?.fetchHeaderContent(t("pages.products.browse_catalog"), "", "");
    let getserviceurl = SERVICES + `?lang=${props.language.toLowerCase()}`;
    let data = await getRequestcall(getserviceurl, "");
    if (data?.status === 200) {
      let getservices = await data.json();
      let geturl = STORE_DETAIL + `/${props?.storeDetail?.store_id}/no`;
      let storeDetailresponse = await getRequestcall(
        geturl,
        props?.access_token
      );
      if (storeDetailresponse?.status === 200) {
        let storedetail = await storeDetailresponse.json();
        let updatedCategorylist = [];
        let serviceArray = storedetail?.data?.service_id?.split(",");
        serviceArray?.forEach((getitem, index) => {
          let getServices = getservices?.data.filter(
            (item) => item.id === getitem
          );
          if(getServices.length > 0) {
            updatedCategorylist.push(getServices[0]);
          }
        });
        setCategorylist(updatedCategorylist);
      } else if(storeDetailresponse?.status === 400) {
        props?.clearStoredetail([]);
        props.logindata.type = "user";
        props.fetchLogindata(props.logindata);
        let getError = await storeDetailresponse.json();
        toast.error(getError?.errors);
        navigate("/vendor/");
      }
    } 
  };

  const selectCategorychange = async (selectCategory) => {
    if (selectCategory?.title !== "Other") {
      let url =
        SUBCATEGORY_LIST +
        `?category=${
          selectCategory?.id
        }&for_master=yes&lang=${props?.language?.toLowerCase()}`;
      let getsubCategorylistapiresponse = await getRequestcall(
        url,
        props?.access_token
      );
      if (getsubCategorylistapiresponse?.status === 200) {
        let res = await getsubCategorylistapiresponse.json();
        if (res?.length === 0) {
          navigate("product", {
            state: { catagory: selectCategory?.id, subcatagory: [] },
          });
        } else {
           navigate(selectCategory?.id);
        }
      }
    } else {
      toast.info(t("pages.catalog.add_manual"));
    }
  };

  return (
    <div className="col-xl-9 main-content catalog_content">
      <div className="card catalog_card">
        <div className="card-body catalog_body">
          <div
            className={"d-flex align-items-start mb-3 justify-content-between"}
          >
            <h3 className="header-title mb-0">{t("pages.catalog.title")}</h3>
            <ButtonPage 
              onClick={() => navigate("/vendor/products/add")}
              className={"button-black"}
              Text= {t("pages.catalog.addmanual")}
            />
          </div>
          <Row className={"catalog_list"}>
            {categorylist?.map(
              (item, index) =>
                item?.type === "goods" ? (
                  <CategorycardPage card_style={goods_card} selectCategorychange={selectCategorychange} item={item} type={"goods"}/>
                ):(
                  <CategorycardPage card_style={service_card} selectCategorychange={selectCategorychange} item={item} type={"service"}/>
                )
            )}
          </Row>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  storeDetail: state?.dashboard?.storeDetail,
  access_token: state?.login.access_token,
  categories: state?.home.categories,
  language: state?.languageState?.language,
  logindata: state?.login?.logindata
});

export default connect(mapStateToProps, {
  fetchHeaderContent,
  clearStoredetail,
  fetchLogindata
})(CatelogPage);
